<template>
<div>
  <el-form style="margin-right: 30px" :model="addEditForm" :rules="addEditRules" ref="addEditForm" label-width="100px" class="demo-ruleForm">
    <el-form-item label="项目名称" prop="project_name">
      <el-input v-model="addEditForm.project_name" placeholder="请输入项目名称"></el-input>
    </el-form-item>
    <el-form-item label="项目金额" prop="project_amount">
      <el-input type="number" v-model="addEditForm.project_amount" placeholder="请输入项目金额（元）"></el-input>
    </el-form-item>
    <el-form-item label="收费周期" prop="project_cycle_unit">
      <el-select v-fixZoom v-model="addEditForm.project_cycle_unit" filterable placeholder="请选择" style="width: 100%">
        <el-option v-for="item in projectCycle" :key="item.id" :label="item.name" :value="item.id">
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="周期数量" prop="project_cycle_num">
      <el-input type="number" v-model="addEditForm.project_cycle_num" placeholder="请输入周期数量"></el-input>
    </el-form-item>
    <el-form-item label="备注" prop="">
      <el-input type="textarea" :rows="2" v-model="addEditForm.project_remark" placeholder="请输入备注"></el-input>
    </el-form-item>
  </el-form>
  <div style="height: 50px">
    <el-row style="margin: 0 20px">
      <el-col :span="12">
        <div class="cancel-btn" @click="closeAddEdit()">
          <span>取消</span>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="send-btn" @click="submitAddEditUnit('addEditForm')">
          <span>确定</span>
        </div>
      </el-col>
    </el-row>
  </div>
</div>
</template>

<script>
import {createfinanceproject, updatefinanceproject} from '../../../api/yanglaoyuan'

export default {
  name: 'addEditCharge',
  model: {
    prop: 'addEditShow',
    event: 'change'
  },
  props: {
    addEditObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      oldPersonArr: [],
      projectCycle: [
        {id: 2, name: '季'},
        {id: 3, name: '年'},
        {id: 1, name: '月'},
        {id: 4, name: '天'},
        {id: 5, name: '一次性'}
      ],
      addEditForm: {
        'id': 0,
        'eid': 1,
        'project_name': '',
        'project_amount': '',
        'project_remark': '',
        'project_cycle_unit': '',
        'project_cycle_num': '',
        'project_status': 1
      },
      addEditRules: {
        project_name: [
          {required: true, message: '请输入项目名称', trigger: 'blur'}
        ],
        project_amount: [
          {required: true, message: '请输入项目收费金额', trigger: 'blur'}
        ],
        project_cycle_unit: [
          {required: true, message: '请选择收费周期', trigger: 'change'}
        ],
        project_cycle_num: [
          {required: true, message: '请输入收费周期数量', trigger: 'blur'}
        ]
      }
    }
  },
  created () {
    if (this.addEditObj.isAdd) {
      this.addEditForm.eid = this.$store.state.user.LoginResp.entity_id
    } else {
      this.addEditForm = {
        'id': this.addEditObj.row.id,
        'eid': this.addEditObj.row.eid,
        'project_name': this.addEditObj.row.project_name,
        'project_amount': this.addEditObj.row.project_amount,
        'project_remark': this.addEditObj.row.project_remark,
        'project_cycle_unit': this.addEditObj.row.project_cycle_unit,
        'project_cycle_num': this.addEditObj.row.project_cycle_num,
        'project_status': this.addEditObj.row.project_status
      }
    }
  },
  methods: {
    closeAddEdit () {
      this.$emit('change', false)
    },
    submitAddEditUnit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {
            'id': this.addEditForm.id,
            'eid': this.addEditForm.eid,
            'project_name': this.addEditForm.project_name,
            'project_amount': parseFloat(this.addEditForm.project_amount),
            'project_remark': this.addEditForm.project_remark,
            'project_cycle_unit': parseInt(this.addEditForm.project_cycle_unit),
            'project_cycle_num': parseInt(this.addEditForm.project_cycle_num),
            'project_status': parseInt(this.addEditForm.project_status)
          }
          if (this.addEditObj.isAdd) {
            createfinanceproject(data).then(res => {
              this.$notify({title: '成功', message: '成功新增收费项目', type: 'success', duration: 2000})
              this.$emit('updateTable')
              this.$emit('change', false)
            })
          } else {
            updatefinanceproject(data).then(res => {
              this.$notify({title: '成功', message: '成功编辑收费项目', type: 'success', duration: 2000})
              this.$emit('updateTable')
              this.$emit('change', false)
            })
          }
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/components/addEditCharge.vue